import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";

const { siteMetadata: config } = GatsbyConfig;

export default class PhoneCallout extends React.Component {
  render() {
    if (!config.showPhone) return null;

    return (
      <div className="phone-callout">
        <div className="wrap">
          <h2>{config.phone}</h2>
          <h3>{config.officeHours}</h3>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/phone-callout.js